// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import styled from "styled-components";

import { typography } from "../../styles";

export const Sans12 = styled.div`
  ${typography.Sans12}
`;
Sans12.displayName = "Sans12";

export const Sans14 = styled.div`
  ${typography.Sans14}
`;
Sans14.displayName = "Sans14";

export const Sans16 = styled.div`
  ${typography.Sans16}
`;
Sans16.displayName = "Sans16";

export const Sans18 = styled.div`
  ${typography.Sans18}
`;
Sans18.displayName = "Sans18";

export const Sans24 = styled.div`
  ${typography.Sans24}
`;
Sans24.displayName = "Sans24";

export const Serif24 = styled.div`
  ${typography.Serif24}
`;
Serif24.displayName = "Serif24";

export const Serif34 = styled.div`
  ${typography.Serif34}
`;
Serif34.displayName = "Serif34";
